import React from "react";
import { Form, Input, Button, Card, Typography } from "antd";
import { useAdminPasswordUpdate } from "../../../hooks/api/user/hooks";
import { useMessageApi } from "../../../provider/AntdNotification";

const { Title } = Typography;

const Profile: React.FC = () => {
    const message = useMessageApi();
  
  const [form] = Form.useForm();
  
  const { mutate: updatePassword, isPending } = useAdminPasswordUpdate({
    onSuccess: (res) => {
      message.success("Password updated successfully");
      form.resetFields();
    },

    onError: (error: any) => {
      console.log(error, "error");
      message.error(error.message);
    },

  });

  const onFinish = (values: any) => {
    updatePassword(values);
  };

  return (
    <div className="p-6">
      <Card title={<Title level={4}>Change Password</Title>} className="max-w-2xl mx-auto shadow-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="currentPassword"
            label="Current Password"
            rules={[{ required: true, message: "Please enter your current password" }]}
          >
            <Input.Password placeholder="Current Password" size="large" />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[{ required: true, message: "Please enter your new password" }]}
          >
            <Input.Password placeholder="New Password" size="large" />
          </Form.Item>

          <Form.Item
            name="confirmNewPassword"
            label="Confirm New Password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("The two passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm New Password" size="large" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isPending}
              size="large"
              className=" w-full md:w-auto mt-4"
            >
              Update Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Profile;
